// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"262":"bulkrequest","651":"bulkcollect"}[chunkId] + "." + {"262":"ff70d61c","651":"e4d50911"}[chunkId] + ".css";
};